const pickString = value => {
  if (typeof value === 'string' && value.trim()) {
    return value
  }
  if (Array.isArray(value)) {
    const first = value.find(item => typeof item === 'string' && item.trim())
    return first || undefined
  }
  return undefined
}

export const getApiErrorMessage = err => {
  const data = err && err.response && err.response.data
  if (!data) {
    return undefined
  }

  const asString = pickString(data)
  if (asString) {
    return asString
  }

  const candidates = [
    data.error && data.error.message,
    data.message,
    data.exception && data.exception.message,
    data.exception && data.exception.response,
    data.nestjsError && data.nestjsError.message,
    data.nestjsError && data.nestjsError.response,
    data.error,
  ]

  for (const candidate of candidates) {
    const message = pickString(candidate)
    if (message) {
      return message
    }
  }

  return undefined
}



// WEBPACK FOOTER //
// ./src/utils/apiError.js